import React from "react";
import ReactDOM from "react-dom/client";
import Consulta from "./Consulta";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<Consulta />);
